const ROOT_URL = `/waitlist/api/`;

export const routes = {
  cancelVisit: `${ROOT_URL}cancelVisit`,
  getWaitlist: `${ROOT_URL}getWaitlist`,
  checkInData: `${ROOT_URL}checkInData`,
  getBusinessDetails: `${ROOT_URL}getBusinessDetails`,
  getReservationData: `${ROOT_URL}getReservationData`,
  getPublicWaitlist: `${ROOT_URL}getPublicWaitlist`,
  createPendingVisit: `${ROOT_URL}createPendingVisit`,
  verifyPendingVisitCode: `${ROOT_URL}verifyPendingVisitCode`,
  bookReservation: `${ROOT_URL}bookReservation`,
  putToWaitlist: `${ROOT_URL}putToWaitlist`,
  logError: `${ROOT_URL}logError`,
  getSelfBookingAvailableSlots: `${ROOT_URL}selfBooking/slots`,
  createReservationWithPendingStatus: `${ROOT_URL}selfBooking/pending`,
  confirmPendingReservation: `${ROOT_URL}selfBooking/confirm`,
  editReservation: `${ROOT_URL}selfBooking/edit`,
  cancelReservation: `${ROOT_URL}selfBooking/cancel`,
  getReservationById: `${ROOT_URL}reservation`,
  getResourcesByBusinessId: `${ROOT_URL}resources`,

  // Appointments (plan §6). Cancellation is not listed: it only flips a status by id,
  // so the flow reuses `cancelReservation` above rather than aliasing the same handler
  // under a second name.
  appointmentCheckInData: `${ROOT_URL}appointments/checkInData`,
  getAppointmentAvailableSlots: `${ROOT_URL}appointments/slots`,
  getAppointmentDays: `${ROOT_URL}appointments/days`,
  createAppointmentWithPendingStatus: `${ROOT_URL}appointments/pending`,
  confirmAppointment: `${ROOT_URL}appointments/confirm`,
  editAppointment: `${ROOT_URL}appointments/edit`
};
